import CommunityCom from "../component/communityComp/Community";

export default function CommunityPage() {
  return <CommunityCom />;
}
